import React from "react";
import { Link } from "react-router-dom";
import { Translate } from "react-redux-i18n";
import { FaArrowLeft } from "react-icons/fa";

import "./styles/AdMenu.css";
import AdKindPicker from "../components/AdKindPicker";

class AdMenu extends React.Component {
  render() {
    return (
      <div className="admenu-page">
        <div className="admenu-page__inner">
          <header className="admenu-page__header">
            <Link to="/panel/ads" className="admenu-page__back" aria-label="Back">
              <FaArrowLeft />
            </Link>
            <div>
              <h1 className="admenu-page__title">
                <Translate value="ad_new" />
              </h1>
              <p className="admenu-page__subtitle">
                <Translate value="ad_choose_type_hint" />
              </p>
            </div>
          </header>

          <AdKindPicker className="admenu-page__grid" />
        </div>
      </div>
    );
  }
}

export default AdMenu;
